import { findPostPurchaseCheckout } from 'lib/checkout/checkoutUtils'
import getCanShowRegionSpecificLoyaltyUI from 'loyalty/selectors/getCanShowRegionSpecificLoyaltyUI'
import { createSelector } from 'reselect'

const getCanRedeemInsuranceLoyaltyBenefit = createSelector(
  (state: App.State) => state.loyalty.account.data?.benefits,
  (state: App.State) => findPostPurchaseCheckout(state.checkout.cart.mode),
  (state: App.State) => getCanShowRegionSpecificLoyaltyUI(state),
  (userBenefits, isPostPurchase, canShow): boolean => {
    if (!canShow) return false
    const insuranceBenefit = userBenefits?.find(benefit => benefit.code === 'discounted_insurance')
    return !isPostPurchase && !!insuranceBenefit && (insuranceBenefit.unlimited || !!insuranceBenefit.remaining)
  },
)

export default getCanRedeemInsuranceLoyaltyBenefit
